import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import sage from "../../../images/splash/sage.jpeg";
import Nav from 'react-bootstrap/Nav';
import {Navbar,NavDropdown} from 'react-bootstrap';
import { Card, Form, Button, Table } from 'react-bootstrap';
import pro from "../../../images/splash/prof.png";
import axios from "axios";
import { var_api } from "../../constant";
import Modal from 'react-bootstrap/Modal';
import Loader from "../Loader";
import Pagination from 'react-js-pagination';
import React, { useState, useEffect,useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { Step } from '@material-ui/core';

const ReminderMaster = () => {
  const [editMode, setEditMode] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; 
  const [startIndex, setStartIndex] = useState(0);
  const [ searchQuery,setSearchQuery] = useState('');
  const history = useHistory();
  const [reminderList, setRemainderList] = useState([]);
  const [reminderid, setreminderid] = useState('');
  const [title, setTitle] = useState('');
  const [value, setValue] = useState('');
  const [description, setDescription] = useState('');
  const [errors, setErrors] = useState({});


  useEffect(() => {
    fetchRemainderMaster();
}, [currentPage]);

const fetchRemainderMaster = async () => {
  const token = localStorage.getItem('token');
  setIsLogin(true);
  try {
      const response = await axios.get(`${var_api}/api/remainder-master/get`, {
          headers: {
              'Authorization': `${token}`
          }
      });
      setRemainderList(response.data);
      
      setIsLogin(false);
  } catch (error) {
    setRemainderList([]);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
  }
};


const validateForm = () => {
  const newErrors = {};

  if (!title) newErrors.title = 'Title is required';
  if (!value) newErrors.value = 'Value is required';
  if (!description) newErrors.description = 'Description is required';

  return newErrors;
};


const createReminderMaster = async () => {
    const newErrors = validateForm();
    setErrors(newErrors); // Update the state with validation errors
  
    // If there are errors, don't proceed with the form submission
    if (Object.keys(newErrors).length > 0) {
      return;
    }
  
    const token = localStorage.getItem('token');
    setIsLogin(true);
  
    // Create a JSON object instead of FormData
    const payload = {
      title: title,
      value: parseInt(value),
      description: description,
      active_status: 1,
    };
  
    try {
      const response = await axios.post(`${var_api}/api/remainder-master/post`, payload, {
        headers: {
          'Authorization': `${token}`,
          'Content-Type': 'application/json'
        }
      });
  
      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          text: 'Reminder Created Successfully',
          confirmButtonColor: '#007500',
        });
        console.log('Reminder created successfully!');
      }
      fetchRemainderMaster();
      resetForm();
    } catch (error) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
    } finally {
      setIsLogin(false);
    }
  };
  

  const updateReminder = async () => {
    const token = localStorage.getItem('token');
    setIsLogin(true);
    
    const newErrors = validateForm();
    setErrors(newErrors); // Update the state with validation errors
  
    // If there are errors, don't proceed with the form submission
    if (Object.keys(newErrors).length > 0) {
      return;
    }
  
    // Create a JSON object instead of FormData
    const payload = {
      title: title,
      value: value,
      description: description
    };
  
    try {
      const response = await axios.put(`${var_api}/api/remainder-master/put/${reminderid}`, payload, {
        headers: {
          'Authorization': `${token}`,
          'Content-Type': 'application/json'
        }
      });
  
      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          text: 'Reminder Updated Successfully',
          confirmButtonColor: '#007500',
        });
        console.log('Reminder updated successfully!');
      }
      fetchRemainderMaster();
      resetForm();
    } catch (error) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
    } finally {
      setIsLogin(false);
    }
  };
  

  const handleStatusChange = async (employee, newStatus) => {
    const token = localStorage.getItem('token');
    setIsLogin(true);
  
    // Create a JSON object with only the is_active field
    const payload = {
        active_status: newStatus
    };
  
    try {
      const response = await axios.put(`${var_api}/api/remainder-master/put/${employee.id}`, payload, {
        headers: {
          'Authorization': `${token}`,
          'Content-Type': 'application/json'
        }
      });
  
      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          text: 'Reminder Updated Successfully',
          confirmButtonColor: '#007500',
        });
        console.log('Reminder updated successfully!');
      }
      fetchRemainderMaster();
    } catch (error) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
    } finally {
      setIsLogin(false);
    }
  };  


  const resetForm = () => {
    setTitle('');
    setValue('');
    setDescription('');
    setEditMode(false); // Assuming you set profile file
};


const handleEdit = (reminder) => {
    setEditMode(true);
    setreminderid(reminder.id);
    setTitle(reminder.title);
    setValue(reminder.value);
    setDescription(reminder.description);
  };

  const handleSearchInput = (e) => {
    setSearchQuery(e.target.value);
  };
  
  // Filter employees before applying pagination
  const filteredEmployees = Array.isArray(reminderList) && reminderList.filter(reminder => {
    const searchLower = searchQuery.toLowerCase();
    return (
      (reminder.title && reminder.title.toString().toLowerCase().includes(searchLower)) ||
      (reminder.description && reminder.description.toString().toLowerCase().includes(searchLower)) ||
      (reminder.value && reminder.value.toString().toLowerCase().includes(searchLower))
    );
  });
  
  // Apply pagination to the filtered list
  const paginatedFilteredEmployees = filteredEmployees.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber); // Update current page
  };

    return(
        <>
        {isLogin && <Loader />}
        <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
  <Navbar.Brand href="#home">
    <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
  <Nav className="mx-auto">
      <Nav.Link href="#" style={{ color: "black", fontSize:"25px", letterSpacing:"2px" }}>
       REMAINDER MASTER
      </Nav.Link>
    </Nav>
    <Nav className="ms-auto">
      <Nav.Link href="/sb-home" style={{ color: "black", fontSize: "15px" }}>
        <button className="btn" style={{backgroundColor:"rgb(89, 128, 71)", color:"white"}}>
          <i className="bi bi-house"></i> Go to home
        </button>
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>
<br/>
<br/>
<br/>
<br/>
         <div style={{margin:"auto",padding:"20px"}}>
             <Row>
             <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
             <Card style={{ border: "none", maxWidth: "28rem", padding: "15px 27px", margin: "auto", height: "auto", borderRadius: "20px", boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgb(89, 128, 71, 0.50) 0px 3px 6px" }}>
            <Card.Body>
                <h5 style={{ textAlign: "center", color: "rgb(89, 128, 71)", fontWeight: "bold" }}>{editMode ? 'Edit Reminder' : 'Create Reminder'}</h5>
                <Form onSubmit={(e) => e.preventDefault()}>
                    <Form.Group controlId="formBasicName" className="mt-3">
                        <Form.Label>Title</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter Title"
                            name="title"
                            value={title}
                            onChange={(e) =>  setTitle(e.target.value)}
                            required
                        />
                         {errors.title && <p style={{ color: 'red' }}>{errors.title}</p>}
                    </Form.Group>

                    <Form.Group controlId="formBasicEmail" className="mt-3">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter Description"
                            name="description"
                            value={description}
                            onChange={(e) =>  setDescription(e.target.value)}
                            required
                        />
                        {errors.description && <p style={{ color: 'red' }}>{errors.description}</p>}
                    </Form.Group>

                    <Form.Group controlId="formBasicPhone" className="mt-3">
                        <Form.Label>Value</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Enter value"
                            name="value"
                            value={value}
                            onChange={(e) =>  setValue(e.target.value)}
                            required
                        />
                        {errors.value && <p style={{ color: 'red' }}>{errors.value}</p>}
                    </Form.Group>
                     <Button variant="primary" type="button" className="mt-3" 
                      style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)" }}
                      onClick={createReminderMaster} hidden={editMode}  // This will hide the Submit button when editMode is true
                        >
                    Submit
                    </Button>{" "}
                    <Button variant="primary" type="button" className="mt-3"
                     style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)" }}
                     onClick={() => updateReminder()} hidden={!editMode}  // This will hide the Update button when editMode is false
                    >
                    Update
                    </Button>{" "}

                    <Button variant="danger" type="button" className="mt-3" onClick={resetForm}>
                        Reset
                    </Button>
                </Form>
            </Card.Body>
        </Card>
</Col>
                <Col xs={12} md={6} lg={6} xl={8} xxl={8} style={{padding:"0px",margin:"0px"}}>
                <Card style={{ border: "none", maxWidth:"62rem", padding:"20px", margin:"auto", height:"auto", borderRadius:"20px", fontFamily:"Arial, Helvetica, sans-serif" }}>
                 <h5 style={{color:"rgb(89, 128, 71)", fontWeight:"bold"}}>Reminder List  <span style={{float:"right", fontSize:"17px", color:"black", fontWeight:"bold"}}><Form.Control type="text" placeholder="Search..."  onChange={handleSearchInput}/></span> </h5>  

        <Table responsive className="mt-3">
          <thead>
            <tr>
              <th>S.No</th> 
              <th>Title</th>
              <th>Description</th>
              <th>Value</th>
              <th>Action</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
  {paginatedFilteredEmployees.length > 0 ? (
    paginatedFilteredEmployees.map((employee, index) => (
      <tr key={employee.id}>
        <td>{startIndex + index + 1}</td>
        <td>{employee.title}</td>
        <td>{employee.description}</td>
        <td>{employee.value}</td>
        <td>
          <Form.Check
            type="switch"
            id={`custom-switch-${employee.id}`}
            label=""
            checked={employee.active_status === 1}
            onChange={(e) => handleStatusChange(employee, e.target.checked ? 1 : 0)}
          />
        </td>
        <td>
          <Button variant="primary" className="m-1" onClick={() => handleEdit(employee)}>
            <i className="bi bi-pencil-square"></i>
          </Button>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="7" className="text-center">No data available</td>
    </tr>
  )}
</tbody>
</Table>
<Pagination
  activePage={currentPage}
  itemsCountPerPage={itemsPerPage}
  totalItemsCount={filteredEmployees.length} // Update total count to reflect filtered data
  pageRangeDisplayed={5}
  onChange={handlePageChange}
  itemClass="page-item"
  linkClass="page-link"
  innerClass="pagination justify-content-end"
  activeClass="active-pagination"
/>
      </Card>
                </Col>
            </Row>
        </div>
        </>
    )
}

export default ReminderMaster;